// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2bgg4","title":"Images45_title__1Olmc","images":"Images45_images__2XyTL"};